import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DateTimeRange from "../../../components/common/DateTimeRange";
import { url } from "../../../Constant";
import axios from "axios";
import { useAuth } from "../../../Context/AuthProvider";
import $ from "jquery";
import { toast } from "react-toastify";
import moment from "moment";
import { checkIndividualPermission } from "../../../Utils/PermissionFunctions";

const AddGroup = () => {
  const { auth } = useAuth();
  const [groupName, setGroupName] = useState("");
  const [loader, setLoader] = useState(false);
  const [errorEnable, setErrorEnable] = useState(false);

  // const addGroup = (e) => {
  //   e.preventDefault();
  //   setErrorEnable(true);
  //   setLoader(true);

  //   if (groupName !== "") {
  //     axios
  //       .post(url + "create_group", {
  //         vpbx_id: auth.vpbx_id,
  //         status: 1,
  //         group_name: groupName,
  //       }, {
  //         headers: {
  //           Authorization: `Bearer ${auth.token}`,
  //         },
  //       })
  //       .then(
  //         (response) => {
  //           if (response.data.code === 200) {
  //             if (response.data.message === "User Created Successfully") {
  //               setLoader(false);
  //               toast.success("Group created successfully", {
  //                 position: toast.POSITION.TOP_RIGHT,
  //                 autoClose: 1500,
  //               });
  //               setTimeout(() => {
  //                 window.location.href = "/vpbx-manager";
  //               }, 2000);
  //             }
  //           } else  {
  //             toast.error(response?.data?.data?.errors[0], {
  //               position: toast.POSITION.TOP_RIGHT,
  //               autoClose: 1500,
  //             });
  //             setLoader(false);
  //           }
  //         },
  //         (error) => {
  //           console.log(error);
  //         }
  //       );
  //   } else {
  //     setLoader(false);
  //   }
  // };

  useEffect(() => {
    if (
      auth.role === "1" ||
      (auth.role === "3" &&
        !checkIndividualPermission("group", "read_and_write"))
    ) {
      window.location.href = "/";
    }
  }, []);

  const addGroup = (e) => {
    e.preventDefault();
    setErrorEnable(true);
    setLoader(true);
    let api = "";
    if (auth.role === "2") {
      api = "create_group";
    } else {
      api = "user-create-group";
    }
    if (groupName !== "") {
      axios
        .post(
          url + api,
          {
            vpbx_id: auth.vpbx_id,
            status: 1,
            group_name: groupName,
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.message === "User Created Successfully") {
              setLoader(false);
              toast.success("Group created successfully", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
              setTimeout(() => {
                window.location.href = "/vpbx-manager";
              }, 2000);
            }
          } else {
            // Check if there are validation errors returned from the API
            if (
              response.data.data &&
              response.data.data.errors &&
              response.data.data.errors.length > 0
            ) {
              const errorMessage = response.data.data.errors[0];
              toast.error(errorMessage, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
            } else {
              // Handle other API errors
              toast.error(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
            }
            setLoader(false);
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error("An error occurred while creating the group.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
          });
          setLoader(false);
        });
    } else {
      setLoader(false);
    }
  };

  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link to="/vpbx-manager">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX Manager</span>
                </Link>
                <h3>Add Group</h3>
              </div>
            </div>
          </div>
          <form onSubmit={addGroup}>
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">Company information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Company name</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="Company name"
                    onChange={(e) => {
                      setGroupName(e.target.value);
                    }}
                  />
                  {errorEnable && groupName === "" && (
                    <div className="formErrors">Name is required</div>
                  )}
                </div>

                <div className="uk-width-1-1@m uk-float-right">
                  <div className="formActionBtn uk-text-right">
                    {/* <button className="whiteBtn">Cancel</button> */}
                    <button className="pinkBtn" type="submit">
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        " Add Group"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddGroup;
